<template>
  <div v-if="loading" class="txt--main">
    <exc-loader height="14" />
  </div>
  <cards-list-container
    v-else
    :items="investmentCards"
    :loading="loading"
    class="investment-cards-block"
  >
    <template #body="{ cards }">
      <template v-for="(item, index) in cards">
        <investment-card :key="index" :investment="item" />
      </template>
    </template>
  </cards-list-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExcLoader } from '@/components/common'

export default {
  name: 'InvestmentCardsBlock',
  components: {
    CardsListContainer: () =>
      import(
        /* webpackMode: "eager" */ '@/components/containers/CardsListContainer.vue'
      ),
    InvestmentCard: () =>
      import(
        /* webpackMode: "eager" */ '@/components/staking-pool/card/InvestmentCard.vue'
      ),
    ExcLoader,
  },
  data () {
    return {
      loading: true,
    }
  },
  async fetch () {
    if (!this.items.length) {
      this.loading = true
      await this.getStakingGroup()
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      items: 'stakingPool/getStakingGroups',
    }),
    investmentCards () {
      return this.items
    },
    itemsSlice () {
      // hotfix
      return window.innerWidth < 768 ? 4 : 3
    },
  },
  methods: {
    ...mapActions('stakingPool', {
      getStakingGroup: 'getStakingGroup',
    }),
  },
}
</script>
